export const LEGACY_WORDS_PER_TOKEN = 0.75

const positiveNumber = value => {
  const number = Number(value)
  return Number.isFinite(number) && number > 0 ? number : 0
}

export const tokenCountForPack = pack => {
  const tokenCount = positiveNumber(pack && pack.tokenCount)
  if (pack?.tokenCount !== undefined && Number.isFinite(Number(pack.tokenCount))) return tokenCount

  const legacyWordCount = positiveNumber(pack && pack.wordCount)
  return legacyWordCount ? legacyWordCount / LEGACY_WORDS_PER_TOKEN : 0
}

export const createTokenBalanceAccumulator = () => {
  const purchases = new Map()
  return change => {
    const id = change.wordPack.id
    if (change.type === 'removed') purchases.delete(id)
    else if (change.type === 'added' || change.type === 'modified') purchases.set(id, tokenCountForPack(change.wordPack))
    return [...purchases.values()].reduce((total, tokens) => total + tokens, 0)
  }
}

export const formatTokenCount = value => {
  const tokenCount = positiveNumber(value)
  if (tokenCount >= 1_000_000) {
    const millions = tokenCount / 1_000_000
    return `${Number.isInteger(millions) ? millions : millions.toFixed(1)}M`
  }
  if (tokenCount >= 1_000) return `${Math.round(tokenCount / 1_000)}K`
  return Math.round(tokenCount).toLocaleString()
}
